import { Link } from "react-router-dom";
import { usePortfolio } from "@/hooks/useSiteData";
import useSeo from "@/hooks/useSeo";
import { fileUrl } from "@/lib/api";

export default function Portfolio() {
  const { data: items = [], isLoading } = usePortfolio();
  useSeo("Portfolio", "I lavori e i progetti realizzati da POWERCOM nel campo delle telecomunicazioni e degli impianti tecnologici.");
  return (
    <>
      <section className="page-hero">
        <div className="container reveal">
          <span className="eyebrow light">Portfolio</span>
          <h1>I nostri lavori e progetti.</h1>
          <p>Una selezione di interventi realizzati nel campo delle telecomunicazioni e degli impianti tecnologici.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {isLoading ? (
            <p className="empty">Caricamento…</p>
          ) : items.length === 0 ? (
            <div className="empty" data-testid="portfolio-empty">
              <h2>Nessun progetto ancora pubblicato.</h2>
              <p style={{ marginTop: 12 }}>I progetti aggiunti dal backoffice appariranno qui.</p>
              <Link to="/contatti" className="btn" style={{ marginTop: 24 }}>Contattaci</Link>
            </div>
          ) : (
            <div className="portfolio-grid" data-testid="portfolio-grid">
              {items.map((it) => (
                <article className="pf-card reveal" key={it.id} data-testid={`pf-card-${it.id}`}>
                  {it.image_path ? (
                    <img className="pf-img" src={fileUrl(it.image_path)} alt={it.title} />
                  ) : (
                    <div className="pf-img" />
                  )}
                  <div className="pf-body">
                    {it.category && <span className="pf-cat">{it.category}</span>}
                    <h3>{it.title}</h3>
                    {it.description && <p>{it.description}</p>}
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
